import { faSpinner } from "@jewlr/pro-regular-svg-icons/faSpinner"
import { Button, FontAwesomeIcon, Image } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"

import {
  addToWishlist,
  unselectFromWishlist,
} from "areas/collection/store/actions"

const InternalWishlist = ({
  miniview,
  wishlistAdded,
  wishlistLoading,
  toggleAddToWishlist,
}) => {
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!wishlistLoading) {
      setLoading(wishlistLoading)
    }
  }, [wishlistLoading])

  return (
    <Button
      aria-label={
        loading
          ? "Loading wish list"
          : wishlistAdded
          ? "Remove from wish list"
          : "Add to wish list"
      }
      disabled={loading}
      height="30px"
      id={`add-wishlist-btn-${miniview ? "miniview" : "main"}`}
      onClick={(e) => {
        if (!loading) {
          setLoading(true)
          toggleAddToWishlist(e)
        }
      }}
      variant="text"
      width="30px"
    >
      {loading ? (
        <FontAwesomeIcon fontSize="20px" icon={faSpinner} spin />
      ) : (
        <Image
          alt={wishlistAdded ? "Added to wish list" : "Add to wish list"}
          lazyload={false}
          ratio="30 / 26"
          src={
            wishlistAdded
              ? require("images/icons/heart-clicked-v4.svg")
              : require("images/icons/heart-unclicked-v4.svg")
          }
          style={{ verticalAlign: "text-bottom" }}
          width="30px"
        />
      )}
    </Button>
  )
}

InternalWishlist.propTypes = {
  miniview: PropTypes.bool,
  toggleAddToWishlist: PropTypes.func,
  wishlistAdded: PropTypes.bool,
  wishlistLoading: PropTypes.bool,
}

const mapStateToProps = (state) => {
  const styleCode = state.choices.style_code && state.choices.style_code.value
  const wishlistAdded = (state.wishlist.line_items || []).some(
    (line_item) => line_item.style_code === styleCode
  )

  return {
    styleCode,
    wishlistAdded,
    wishlistLoading: state.wishlist.loading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { styleCode, wishlistAdded, wishlistLoading } = stateProps
  const { dispatch } = dispatchProps

  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    toggleAddToWishlist: (e) => {
      if (wishlistLoading) return null
      dispatch(
        wishlistAdded
          ? unselectFromWishlist(styleCode)
          : addToWishlist(styleCode, e.selected_look, "Product")
      )
    },
  }
}

const Wishlist = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(InternalWishlist)

export default Wishlist
